import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getStatusMenu = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetStatusMenu",
    params
  );
};

const getStatusMenuGroup = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/getStatusMenuGroup",
    params
  );
};

const GetDeptStatusMenu = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetDeptStatusMenu",
    params,
  );
};

const getOfficerStatusMenu = (levelId, departmentId, complaintId) => {
  const params = {
    levelId,
    departmentId,
    complaintId,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetOfficerStatusMenu",
    params
  );
};

const getLawOfficerStatusMenu = (levelId, departmentId, complaintId) => {
  const params = {
    levelId,
    departmentId,
    complaintId,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetLawOfficerStatusMenu",
    params
  );
};

const getLegalStatusMenu = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetLegalStatusMenu",
    params
  );
};

const getStatusDamage = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetStatusDamage",
    params
  );
};

const getLeaderLegalStatusMenu = (departmentId, complaintId) => {
  const params = {
    departmentId,
    complaintId,
  }

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetLeaderLegalStatusMenu",
    params
  );
};

const getClueStatusMenu = (type = 1) => {
  const params = {
    type
  }
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetClueStatusMenu",
    params
  );
};

const getProvinceStatusMenu = (complaintId) => {
  const params = {
    complaintId
  }
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetProvinceStatusMenu",
    params
  );
};

const getBangkokStatusMenu = (complaintId) => {
  const params = {
    complaintId
  }
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/ComplaintBangkok/GetBangkokStatusMenu",
    params
  );
};

const GetStatusProcess = (actionType, value) => {
  var initSymbol = "?";
  var url =
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetStatusProcess";

  if (actionType) {
    url = url + initSymbol + "actionType=" + actionType;
    initSymbol = "&";
  }
  if (value) {
    url = url + initSymbol + "value=" + value;
    initSymbol = "&";
  }

  return axiosGet(url);

  
}

const getAiDepartment = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Status/AIDepartment",
    params,
  );
};

const getAiOfficer = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/Status/AIOfficer",
    params,
  );
};

const GetStatusAll = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Status/GetStatusAll"
  );
};

export {
  getStatusMenu,
  GetDeptStatusMenu,
  getOfficerStatusMenu,
  getStatusMenuGroup,
  getLegalStatusMenu,
  getLeaderLegalStatusMenu,
  getLawOfficerStatusMenu,
  getClueStatusMenu,
  getProvinceStatusMenu,
  getBangkokStatusMenu,
  GetStatusProcess,
  getAiDepartment,
  getAiOfficer,
  getStatusDamage,
  GetStatusAll,
};
